import { render, staticRenderFns } from "./AddNewField.vue?vue&type=template&id=f9b13bba&"
import script from "./AddNewField.vue?vue&type=script&lang=js&"
export * from "./AddNewField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports